import React, { useState } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight, FaCalendarAlt } from "react-icons/fa";

export default function CalendarPage() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [view, setView] = useState("month");

 const events = [
  // March --- >
  { id: 1, title: "Rajasthan Desert Safari Tour", start: "2026-03-10", end: "2026-03-11" },
  { id: 2, title: "Kerala Backwater Experience", start: "2026-03-13", end: "2026-03-14" },
  { id: 3, title: "Goa Beach Relaxation Trip", start: "2026-03-16", end: "2026-03-17" },
  { id: 4, title: "Andaman Island Adventure", start: "2026-03-19", end: "2026-03-20" },
  { id: 5, title: "Varanasi Spiritual Journey", start: "2026-03-22", end: "2026-03-23" },
  { id: 6, title: "Himalayan Nature Escape", start: "2026-03-25", end: "2026-03-26" },
  { id: 7, title: "Udaipur Lake City Tour", start: "2026-03-28", end: "2026-03-29" },
  { id: 8, title: "Mysore Heritage Walk", start: "2026-03-31", end: "2026-04-01" },
  { id: 9, title: "Rishikesh Adventure Camp", start: "2026-04-03", end: "2026-04-04" },
  { id: 10, title: "Jaipur Royal Palace Tour", start: "2026-04-06", end: "2026-04-07" },

  // April <-----
  { id: 11, title: "Darjeeling Tea Garden Tour", start: "2026-04-09", end: "2026-04-10" },
  { id: 12, title: "Coorg Coffee Plantation Trip", start: "2026-04-12", end: "2026-04-13" },
  { id: 13, title: "Ooty Hill Station Escape", start: "2026-04-15", end: "2026-04-16" },
  { id: 14, title: "Golden Temple Amritsar Visit", start: "2026-04-18", end: "2026-04-19" },
  { id: 15, title: "Khajuraho Heritage Tour", start: "2026-04-21", end: "2026-04-22" },
  { id: 16, title: "Hampi Historical Exploration", start: "2026-04-24", end: "2026-04-25" },
  { id: 17, title: "Shimla Mountain Getaway", start: "2026-04-27", end: "2026-04-28" },
  { id: 18, title: "Manali Snow Adventure", start: "2026-04-30", end: "2026-05-01" },
  { id: 19, title: "Leh Ladakh Road Trip", start: "2026-05-03", end: "2026-05-04" },
  { id: 20, title: "Taj Mahal Sunrise Tour", start: "2026-05-06", end: "2026-05-07" },

  // May --- >
  { id: 21, title: "Goa Summer Beach Festival", start: "2026-05-09", end: "2026-05-10" },
  { id: 22, title: "Kodaikanal Hill Retreat", start: "2026-05-12", end: "2026-05-13" },
  { id: 23, title: "Munnar Tea Valley Trip", start: "2026-05-15", end: "2026-05-16" },
  { id: 24, title: "Andaman Scuba Diving Tour", start: "2026-05-18", end: "2026-05-19" },
  { id: 25, title: "Ranthambore Wildlife Safari", start: "2026-05-21", end: "2026-05-22" },
  { id: 26, title: "Jim Corbett Jungle Adventure", start: "2026-05-24", end: "2026-05-25" },
  { id: 27, title: "Kerala Ayurveda Retreat", start: "2026-05-27", end: "2026-05-28" },
  { id: 28, title: "Hyderabad Heritage Tour", start: "2026-05-30", end: "2026-05-31" },
  { id: 29, title: "Ajanta Ellora Cave Tour", start: "2026-06-02", end: "2026-06-03" },
  { id: 30, title: "Sikkim Mountain Journey", start: "2026-06-05", end: "2026-06-06" },

  // June <-----
  { id: 31, title: "Meghalaya Waterfall Trip", start: "2026-06-08", end: "2026-06-09" },
  { id: 32, title: "Kaziranga Wildlife Safari", start: "2026-06-11", end: "2026-06-12" },
  { id: 33, title: "Lakshadweep Island Tour", start: "2026-06-14", end: "2026-06-15" },
  { id: 34, title: "Rishikesh River Rafting", start: "2026-06-17", end: "2026-06-18" },
  { id: 35, title: "Chikmagalur Hill Retreat", start: "2026-06-20", end: "2026-06-21" },
  { id: 36, title: "Pondicherry French Town Tour", start: "2026-06-23", end: "2026-06-24" },
  { id: 37, title: "Mahabalipuram Temple Visit", start: "2026-06-26", end: "2026-06-27" },
  { id: 38, title: "Kanyakumari Sunrise Tour", start: "2026-06-29", end: "2026-06-30" },
  { id: 39, title: "Tawang Monastery Trip", start: "2026-07-02", end: "2026-07-03" },
  { id: 40, title: "Spiti Valley Adventure", start: "2026-07-05", end: "2026-07-06" },

  // July ---- >
  { id: 41, title: "Valley of Flowers Trek", start: "2026-07-08", end: "2026-07-09" },
  { id: 42, title: "Kerala Monsoon Tour", start: "2026-07-11", end: "2026-07-12" },
  { id: 43, title: "Goa Monsoon Beach Walk", start: "2026-07-14", end: "2026-07-15" },
  { id: 44, title: "Uttarakhand Mountain Escape", start: "2026-07-17", end: "2026-07-18" },
  { id: 45, title: "Rajasthan Heritage Circuit", start: "2026-07-20", end: "2026-07-21" },
  { id: 46, title: "Delhi Historical Landmarks", start: "2026-07-23", end: "2026-07-24" },
  { id: 47, title: "Mumbai City Explorer", start: "2026-07-26", end: "2026-07-27" },
  { id: 48, title: "Alleppey Houseboat Cruise", start: "2026-07-29", end: "2026-07-30" },
  { id: 49, title: "Coastal Karnataka Tour", start: "2026-08-01", end: "2026-08-02" },
  { id: 50, title: "Dandeli Adventure Camp", start: "2026-08-04", end: "2026-08-05" },

  // August <----
  { id: 51, title: "Kerala Onam Festival Tour", start: "2026-08-07", end: "2026-08-08" },
  { id: 52, title: "Jaipur Cultural Walk", start: "2026-08-10", end: "2026-08-11" },
  { id: 53, title: "Agra Heritage Weekend", start: "2026-08-13", end: "2026-08-14" },
  { id: 54, title: "Hampi Architecture Tour", start: "2026-08-16", end: "2026-08-17" },
  { id: 55, title: "Ooty Nilgiri Train Trip", start: "2026-08-19", end: "2026-08-20" },
  { id: 56, title: "Munnar Nature Retreat", start: "2026-08-22", end: "2026-08-23" },
  { id: 57, title: "Leh Monastery Trail", start: "2026-08-25", end: "2026-08-26" },
  { id: 58, title: "Ladakh Pangong Lake Visit", start: "2026-08-28", end: "2026-08-29" },
  { id: 59, title: "Sundarbans Mangrove Safari", start: "2026-08-31", end: "2026-09-01" },
  { id: 60, title: "Darjeeling Himalayan Ride", start: "2026-09-03", end: "2026-09-04" },

  // September ---- >
  { id: 61, title: "Goa Sunset Beach Tour", start: "2026-09-06", end: "2026-09-07" },
  { id: 62, title: "Coorg Waterfall Trip", start: "2026-09-09", end: "2026-09-10" },
  { id: 63, title: "Andaman Coral Island Tour", start: "2026-09-12", end: "2026-09-13" },
  { id: 64, title: "Jaipur Royal Heritage Tour", start: "2026-09-15", end: "2026-09-16" },
  { id: 65, title: "Varanasi Ganga Aarti Tour", start: "2026-09-18", end: "2026-09-19" },
  { id: 66, title: "Amritsar Wagah Border Tour", start: "2026-09-21", end: "2026-09-22" },
  { id: 67, title: "Kashmir Valley Trip", start: "2026-09-24", end: "2026-09-25" },
  { id: 68, title: "Gulmarg Gondola Ride", start: "2026-09-27", end: "2026-09-28" },
  { id: 69, title: "Pahalgam River Valley Tour", start: "2026-09-30", end: "2026-10-01" },
  { id: 70, title: "Rajasthan Camel Safari", start: "2026-10-03", end: "2026-10-04" },

  // October <----
  { id: 71, title: "Kolkata Durga Puja Festival Tour", start: "2026-10-06", end: "2026-10-07" },
  { id: 72, title: "Mysore Dasara Celebration Tour", start: "2026-10-09", end: "2026-10-10" },
  { id: 73, title: "Delhi Cultural Festival Walk", start: "2026-10-12", end: "2026-10-13" },
  { id: 74, title: "Jaipur Pink City Tour", start: "2026-10-15", end: "2026-10-16" },
  { id: 75, title: "Agra Taj Heritage Tour", start: "2026-10-18", end: "2026-10-19" },
  { id: 76, title: "Himachal Snow View Tour", start: "2026-10-21", end: "2026-10-22" },
  { id: 77, title: "Kerala Backwater Cruise", start: "2026-10-24", end: "2026-10-25" },
  { id: 78, title: "Goa Cultural Beach Tour", start: "2026-10-27", end: "2026-10-28" },
  { id: 79, title: "Lakshadweep Coral Island Trip", start: "2026-10-30", end: "2026-10-31" },
  { id: 80, title: "Rishikesh Yoga Retreat", start: "2026-11-02", end: "2026-11-03" },

  // November <---
  { id: 81, title: "Varanasi Dev Deepawali Tour", start: "2026-11-05", end: "2026-11-06" },
  { id: 82, title: "Pushkar Camel Fair Tour", start: "2026-11-08", end: "2026-11-09" },
  { id: 83, title: "Jaisalmer Desert Festival Tour", start: "2026-11-11", end: "2026-11-12" },
  { id: 84, title: "Udaipur Royal Palace Visit", start: "2026-11-14", end: "2026-11-15" },
  { id: 85, title: "Mount Abu Hill Retreat", start: "2026-11-17", end: "2026-11-18" },
  { id: 86, title: "Kashmir Winter Snow Tour", start: "2026-11-20", end: "2026-11-21" },
  { id: 87, title: "Manali Snow Adventure", start: "2026-11-23", end: "2026-11-24" },
  { id: 88, title: "Shimla Winter Festival Tour", start: "2026-11-26", end: "2026-11-27" },
  { id: 89, title: "Kerala Spice Garden Tour", start: "2026-11-29", end: "2026-11-30" },
  { id: 90, title: "Goa Beach Carnival Tour", start: "2026-12-02", end: "2026-12-03" },

  // December ---- >
  { id: 91, title: "Andaman Winter Island Trip", start: "2026-12-05", end: "2026-12-06" },
  { id: 92, title: "Leh Ladakh Frozen Lake Tour", start: "2026-12-08", end: "2026-12-09" },
  { id: 93, title: "Kerala Christmas Backwater Cruise", start: "2026-12-11", end: "2026-12-12" },
  { id: 94, title: "Goa Christmas Beach Festival", start: "2026-12-14", end: "2026-12-15" },
  { id: 95, title: "Rajasthan Winter Desert Safari", start: "2026-12-17", end: "2026-12-18" },
  { id: 96, title: "Jaipur Heritage Festival Tour", start: "2026-12-20", end: "2026-12-21" },
  { id: 97, title: "Delhi Winter Food Festival Tour", start: "2026-12-23", end: "2026-12-24" },
  { id: 98, title: "Manali Christmas Snow Trip", start: "2026-12-26", end: "2026-12-27" },
  { id: 99, title: "Shimla Snow Celebration", start: "2026-12-29", end: "2026-12-30" },
  { id: 100, title: "New Year Goa Beach Party", start: "2026-12-31", end: "2027-01-01" }
];

  const getEventsForDate = (date) => {
    return events.filter(
      (event) =>
        new Date(date) >= new Date(event.start) &&
        new Date(date) <= new Date(event.end),
    );
  };

  const handlePrev = () => {
    if (view === "month") {
      setCurrentDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1),
      );
    }
    if (view === "week") {
      const newDate = new Date(currentDate);
      newDate.setDate(newDate.getDate() - 7);
      setCurrentDate(newDate);
    }
    if (view === "day") {
      const newDate = new Date(currentDate);
      newDate.setDate(newDate.getDate() - 1);
      setCurrentDate(newDate);
    }
  };

  const handleNext = () => {
    if (view === "month") {
      setCurrentDate(
        new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
      );
    }
    if (view === "week") {
      const newDate = new Date(currentDate);
      newDate.setDate(newDate.getDate() + 7);
      setCurrentDate(newDate);
    }
    if (view === "day") {
      const newDate = new Date(currentDate);
      newDate.setDate(newDate.getDate() + 1);
      setCurrentDate(newDate);
    }
  };

  const renderMonthView = () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();

    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const firstDay = new Date(year, month, 1).getDay();

    const cells = [];

    for (let i = 0; i < firstDay; i++) {
      cells.push(<Col key={"empty" + i} className="border p-3"></Col>);
    }

    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day);

      const isToday = date.toDateString() === new Date().toDateString();

      cells.push(
        <Col
          key={day}
          xs={12}
          sm={6}
          md={3}
          lg={1}
          className={`border p-2 ${isToday ? "bg-light" : ""}`}
          style={{ minHeight: "120px" }}
        >
          <div className="fw-bold">{day}</div>

          {getEventsForDate(date).map((event) => (
            <Card key={event.id} className="mt-1 bg-primary text-white">
              <Card.Body className="p-1">
                <small>{event.title}</small>
              </Card.Body>
            </Card>
          ))}
        </Col>,
      );
    }

    return (
      <>
        <Row className="text-center fw-bold bg-light border">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
            <Col key={d} className="border p-2">
              {d}
            </Col>
          ))}
        </Row>
        <Row>{cells}</Row>
      </>
    );
  };

  const renderWeekView = () => {
    const start = new Date(currentDate);
    start.setDate(currentDate.getDate() - currentDate.getDay());

    const days = [];

    for (let i = 0; i < 7; i++) {
      const day = new Date(start);
      day.setDate(start.getDate() + i);

      days.push(
        <Col key={i} className="border p-3">
          <div className="fw-bold">{day.toDateString()}</div>

          {getEventsForDate(day).map((event) => (
            <Card key={event.id} className="mt-2 bg-success text-white">
              <Card.Body>{event.title}</Card.Body>
            </Card>
          ))}
        </Col>,
      );
    }

    return <Row>{days}</Row>;
  };

  const renderDayView = () => {
    const dayEvents = getEventsForDate(currentDate);

    return (
      <Row>
        <Col>
          <h5 className="fw-bold">{currentDate.toDateString()}</h5>

          {dayEvents.length === 0 && <p className="text-muted">No Events</p>}

          {dayEvents.map((event) => (
            <Card key={event.id} className="mb-3 bg-warning">
              <Card.Body>{event.title}</Card.Body>
            </Card>
          ))}
        </Col>
      </Row>
    );
  };

  return (
    <Container fluid className="p-4">
      {/* HEADER */}
      <Row className="align-items-center mb-4">
        <Col md={4}>
          <h4 className="fw-bold">
            <FaCalendarAlt className="me-2" />
            Calendar
          </h4>
        </Col>

        <Col md={4} className="text-center">
          <Button variant="light" onClick={handlePrev}>
            <FaChevronLeft />
          </Button>

          <span className="mx-3 fw-bold">
            {currentDate.toLocaleString("default", { month: "long" })}
            {currentDate.getFullYear()}
          </span>

          <Button variant="light" onClick={handleNext}>
            <FaChevronRight />
          </Button>
        </Col>

        <Col md={4} className="text-end">
          <Button
            size="sm"
            className="me-2"
            variant={view === "day" ? "primary" : "outline-primary"}
            onClick={() => setView("day")}
          >
            Day
          </Button>

          <Button
            size="sm"
            className="me-2"
            variant={view === "week" ? "primary" : "outline-primary"}
            onClick={() => setView("week")}
          >
            Week
          </Button>

          <Button
            size="sm"
            variant={view === "month" ? "primary" : "outline-primary"}
            onClick={() => setView("month")}
          >
            Month
          </Button>
        </Col>
      </Row>

      {view === "month" && renderMonthView()}
      {view === "week" && renderWeekView()}
      {view === "day" && renderDayView()}
    </Container>
  );
}
